import { FacebookEventNames, FacebookPurchaseParams } from '../../entities';
import { AppnebulaFacebookService, FacebookService } from '../../interfaces';

export class AppnebulaHttpFacebookService implements AppnebulaFacebookService {
  constructor(private readonly facebookService: FacebookService) {}

  purchase({ ltvPredict, orderId, currency }: FacebookPurchaseParams) {
    this.facebookService.track(FacebookEventNames.PURCHASE, orderId, {
      currency: currency,
      value: ltvPredict,
    });
  }

  addToCart(orderId: string) {
    this.facebookService.track(FacebookEventNames.ADD_TO_CART, orderId, {});
  }

  initiateCheckout(orderId: string) {
    this.facebookService.track(FacebookEventNames.INITIATE_CHECKOUT, orderId, {});
  }
}
